// RM34 official theme helpers: safe, no dependency, no blocking
(() => {
  document.documentElement.classList.add('rm34-official-ready');
  document.querySelectorAll('a[href^="tel:"]').forEach((link) => {
    link.setAttribute('aria-label', link.getAttribute('aria-label') || 'Appeler RM34 Repair Mobile');
  });
})();

document.addEventListener('DOMContentLoaded', function(){
  var toggle = document.querySelector('.rm34-menu-toggle');
  var nav = document.getElementById('rm34-main-nav');
  if(toggle && nav){
    var closeMenu = function(){
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', function(){
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        if (window.matchMedia('(max-width: 1040px)').matches) closeMenu();
      });
    });
    window.addEventListener('resize', function(){
      if (!window.matchMedia('(max-width: 1040px)').matches) closeMenu();
    });
  }
});
